import React from "react";
import AboutItem from "../FeaturedAbout/AboutItem";
import cx from "classnames";
import styles from "./PeopleAndCulture.module.scss";
import ImagesGroup from "./ImagesGroup";
import { usePageContext } from "@providers/PageProvider";
import { careerPage } from "@utils/helper";
import _ from "lodash";

export default function PeopleAndCulture() {
  const { pageData } = usePageContext();
  const peopleAndCulture = careerPage.formatPeopleAndCulture(pageData);

  return (
    <div data-scroll-section className={cx(styles.peopleAndCultureSection)}>
      <AboutItem
        className={cx(styles.item)}
        images={{
          className: styles.images,
          placement: "left",
          node: <ImagesGroup images={_.get(peopleAndCulture, "images")} />,
        }}
        aside={{
          placement: "right",
          className: cx(styles.asideItem),
          content: {
            className: cx(styles.contentItem),
            title: _.get(peopleAndCulture, "title"),
            text: _.get(peopleAndCulture, "description"),
          },
        }}
      />
    </div>
  );
}
